import { newsAndEventsPlaceHolderData } from '~/utils/placeholderData'

export default (centerRoute, limit = null) => {
    const eventsAndNewsApi = `/api/center/centers/${centerRoute}/events-and-news`
    const eventsAndNewsApiWithLimit = limit ? `${eventsAndNewsApi}?limit=${limit}` : eventsAndNewsApi

    return useFetchWithTanstackQuery({
        queryKey: ['eventsAndNews', centerRoute],
        queryFn: () => $fetch(eventsAndNewsApiWithLimit),
        options: {
            placeholderData: newsAndEventsPlaceHolderData,
            staleTime: 5 * 60 * 1000 // 5 min
        }
    })
}
